export default __webpack_public_path__ + "static/media/warning.e4e54aa8.svg";